<template>
    <div class="app-contacts-import">

        <!-- Título / Breadcrumbs / Botões -->
        <mu-row justify-content="center" align-items="center">
            <mu-col span="6" sm="6" md="6" lg="6" xl="6">

                <!-- Título da página -->
                <mu-title color="secondary" textStrong="700">Importação</mu-title>

                <!-- Breadcrumbs -->
                <mu-breadcrumbs divider="—">
                    <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
                    <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
                </mu-breadcrumbs>
            </mu-col>
            <mu-col span="6" sm="6" md="6" lg="6" xl="6">

                <div class="submenu">
                    <!-- Menu Mobile -->
                    <mu-menu cover placement="left-start" class="menu-mobile">
                        <mu-button icon>
                            <font-awesome-icon icon="ellipsis-v" class="icon-md"/>
                        </mu-button>
                        <mu-list slot="content" class="mu-list-custom">
                            <mu-list-item button @click="load()" color="#ddd" textColor="#666" class="btn-update">
                                <mu-list-item-title>Atualizar</mu-list-item-title>
                                <mu-list-item-action><font-awesome-icon icon="redo-alt" class="icon-md icon-margin-left"/></mu-list-item-action>
                            </mu-list-item>
                            <mu-list-item button v-for="(item, key) in submenu" :to="{ name: item.route }" :color="item.color" :textColor="item.textColor" :key="key">
                                <mu-list-item-title>{{ item.name }}</mu-list-item-title>
                                <mu-list-item-action><font-awesome-icon :icon="item.icon" class="icon-md icon-margin-left"/></mu-list-item-action>
                            </mu-list-item>
                        </mu-list>
                    </mu-menu>

                    <!-- Menu Desktop -->
                    <mu-flex justify-content="end" align-items="center" class="menu-desktop">
                        <mu-button  round color="#ddd" textColor="#666" @click="load()">
                            <font-awesome-icon icon="redo" class="icon-md icon-margin-left"/>
                            Atualizar
                        </mu-button>
                        <mu-button v-for="(item, key) in submenu" :to="{ name: item.route }" round :color="item.color" :textColor="item.textColor" :key="key">
                            <font-awesome-icon :icon="item.icon" class="icon-md icon-margin-left"/>
                            {{ item.name }}
                        </mu-button>
                    </mu-flex>
                </div>
            </mu-col>
        </mu-row>

        <br>

        <!-- Formulário para importar contatos -->
        <div class="imports" v-if="!imports.loading">
            <mu-paper :z-depth="1">

                <!-- Listagem dos grupos -->
                <mu-data-table :columns="imports.columns" :data="imports.list" v-if="viewport !== 'mobile'" class="mu-table-custom">
                    <template slot="empty">
                        <div class="box-table-empty">
                            Não foi encontrado registros de grupos.
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <td>{{ scope.row.description }}</td>
                        <td>
                            <div v-if="scope.row.group_Id">
                                {{ scope.row.groups.name }}
                            </div>
                            <div v-else>
                                {{ scope.row.group_Name }}
                            </div>
                        </td>
                        <td class="is-center">
                            <div v-if="scope.row.status == 1">
                                {{ scope.row.valid_Contacts }} / {{ scope.row.inValid_Contacts }} <mu-button v-if="scope.row.invalid_text" flat color="primary" class="btn-numlist" v-on:click="openContactDialog(scope.row.invalid_text)">Ver Números</mu-button>
                            </div>
                            <div v-else>
                                -
                            </div>
                        </td>
                        <td class="is-center">
                            <div v-if="scope.row.status == 1">
                                {{ scope.row.total_Contacts }}
                            </div>
                            <div v-else>
                                -
                            </div>
                        </td>
                        <td class="is-center">
                            <div v-if="scope.row.status == 0">
                                <mu-circular-progress color="gray" :stroke-width="1" :size="14"></mu-circular-progress>
                            </div>
                            <div v-else-if="scope.row.status == 1">
                                <mu-dot color="green"></mu-dot>
                            </div>
                            <div v-else-if="scope.row.status == 2">
                                <mu-dot color="red"></mu-dot>
                            </div>
                        </td>
                    </template>
                </mu-data-table>

                <mu-dialog title="Contatos inválidos" width="360" :open.sync="invalidContacts">
                    <div class="loop-dialog">
                        <p v-for="(n, index) in phonesInvalid" :key="index" class="invalid-number">{{ n }}</p>
                    </div>
                    <mu-button slot="actions" flat color="primary" @click="closeContactDialog()">Fechar</mu-button>
                </mu-dialog>

                <!-- Listagem de grupos mobile -->
                <mu-list textline="two-line" v-if="viewport === 'mobile'">
                    <span v-for="(item, key) in imports.list" :key="key">
                        <mu-list-item>
                            <mu-list-item-action>
                                <div v-if="item.status == 0">
                                    <mu-circular-progress color="gray" :stroke-width="1" :size="14"></mu-circular-progress>
                                </div>
                                <div v-else-if="item.status == 1">
                                    <mu-dot color="green"></mu-dot>
                                </div>
                                <div v-else-if="item.status == 2">
                                    <mu-dot color="red"></mu-dot>
                                </div>
                            </mu-list-item-action>
                            <mu-list-item-content>
                                <mu-list-item-title>{{ item.group_Name }}</mu-list-item-title>
                                <mu-list-item-sub-title>
                                    <div v-if="item.status == 1">
                                        {{ item.total_Contacts }} Contatos <br>
                                        <span class="valid-invalid">{{ item.valid_Contacts }} Válidos / {{ item.inValid_Contacts }} Inválidos</span>
                                    </div>
                                </mu-list-item-sub-title>
                            </mu-list-item-content>
                        </mu-list-item>
                        <mu-divider></mu-divider>
                    </span>
                </mu-list>
            </mu-paper>

            <!-- Paginação -->
            <mu-flex class="paginate" justify-content="center" v-if="imports.paging.total > imports.paging.size">
                <mu-pagination :total="imports.paging.total" :page-count="5" :page-size="imports.paging.size" :current.sync="imports.paging.page" @change="load()"></mu-pagination>
            </mu-flex>

            <!-- Legenda -->
            <div class="legend">
                <table>
                    <tbody>
                        <tr>
                            <td><strong>LEGENDA:</strong></td>
                        </tr>
                        <tr>
                            <td><mu-circular-progress color="gray" :stroke-width="1" :size="14"></mu-circular-progress> Aguardando Processamento</td>
                        </tr>
                        <tr>
                            <td><mu-dot color="green"></mu-dot> Processado</td>
                        </tr>
                        <tr>
                            <td><mu-dot color="red"></mu-dot> Falha ao processar</td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>

        <!-- Loading -->
        <mu-loading text="Carregando a lista de grupos" v-if="imports.loading"></mu-loading>

    </div>
</template>

<script>
    import ImportServices from '@/services/contacts/import'

    export default {
        name: 'app-contacts-import',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Contatos',
                        route: 'app.contacts',
                        disabled: false
                    },
                    {
                        text: 'Importação',
                        disabled: true
                    }
                ],
                submenu: [
                    {
                        name: 'Criar Importação',
                        icon: 'plus',
                        route: 'app.contacts.import.create',
                        color: 'primary',
                        textColor: null
                    }
                ],
                imports: {
                    loading: false,
                    paging: {
                        page: 1,
                        size: 10,
                        total: 0
                    },
                    columns: [
                        { title: 'Descrição', name: 'group_id' },
                        { title: 'Grupo', name: 'name' },
                        { title: 'Válidos / Inválidos', name: 'valids', align: 'center' },
                        { title: 'Total', name: 'total', align: 'center' },
                        { title: 'Status', name: 'status', align: 'center' }
                    ],
                    list: []
                },
                invalidContacts: false,
                phonesInvalid: ''
            }
        },

        // ╔═╗╦═╗╔═╗╔═╗╔╦╗╔═╗╔╦╗
        // ║  ╠╦╝║╣ ╠═╣ ║ ║╣  ║║
        // ╚═╝╩╚═╚═╝╩ ╩ ╩ ╚═╝═╩╝

        /**
         * Acessamos o load para carregar a lista de grupos assim que
         * o componente é montado
         */
        created () {
            this.load()
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {
            openContactDialog (phone) {
                this.phonesInvalid = phone.split(',')
                this.invalidContacts = true
            },

            closeContactDialog () {
                this.phonesInvalid = []
                this.invalidContacts = false
            },

            /**
             * Carrega a lista de grupos passando a paginação
             */
            async load () {
                try {
                    this.imports.loading = true
                    let result = await ImportServices.findAll({
                        page: this.imports.paging.page
                    })
                    if (result && result.status) {
                        this.imports.paging.page = result.currentPage
                        this.imports.paging.total = result.rowCount
                        this.imports.list = result.results
                        return
                    }
                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os dados.')
                } finally {
                    this.imports.loading = false
                }
            }
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {

            /**
             * Utilizado para verificar se o acesso é de desktop, table ou mobile
             */
            viewport () {
                return this.$currentViewport.label
            }
        }

    }
</script>

<style lang="stylus" scoped>

    @import './../../../../assets/stylus/bootstrap.styl'

    .app-contacts-import

        .mu-pagination
            margin-top 20px

        .mu-item-action > div
            margin auto

        .menu-desktop
            display none !important
            text-align right
            .mu-button
                margin-left 5px

        .legend
            margin-top 20px

            table
                tr
                    td
                        padding-right 20px
                        font-size 11px
                        text-transform uppercase

                        .mu-circular-progress, .mu-dot
                            margin-right 4px

        .valid-invalid
            background #f5f5f5
            font-size 10px
            text-transform uppercase
            padding 2px
            color #999

    .btn-numlist
        text-transform inherit
        font-size 12px

    .invalid-number
        margin 0px 0px 2px 0px
        padding 5px
        border-bottom 1px solid #8a2c8a69

    .loop-dialog
        max-height 280px
        overflow-y scroll

    .app-contacts-import .menu-desktop .mu-button[data-v-08c2c4cc]
        vertical-align middle

    /* Tablet >= 768 pixels */
    @media (min-width: 768px)

        .app-contacts-import

            .menu-desktop
                display block !important

</style>
